import { render } from "./KuboardSprayTime.vue?vue&type=template&id=6e288dce&scoped=true"
import script from "./KuboardSprayTime.vue?vue&type=script&lang=js"
export * from "./KuboardSprayTime.vue?vue&type=script&lang=js"

import "./KuboardSprayTime.vue?vue&type=style&index=0&id=6e288dce&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./KuboardSprayTime.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e288dce"]])

export default __exports__